import { module } from 'angular';
import mfComponent from './mf.component';
import mfInputDirective from './mf-input.directive';
import MfParseDirective from './mf-parse.directive';
import mfMatchComponent from './mf-match.component';
import mfPopupComponent from './mf-popup.component';
import mfValuesComponent from './mf-values.component';
import '../kform/components/mf/mf.config';
import '../kform/components/mf/mf.run';
import './mf.scss';

const mfParseDirective = /* @ngInject */ (
	/** @type {import('angular').IParseService} */ $parse,
	/** @type {import('angular').IQService} */ $q,
) => new MfParseDirective($parse, $q);

export default module('app')
	.component('mf', mfComponent)
	// @ts-ignore
	.directive('mfInput', mfInputDirective)
	// @ts-ignore
	.directive('mfParse', mfParseDirective)
	.component('mfMatch', mfMatchComponent)
	.component('mfPopup', mfPopupComponent)
	.component('mfValues', mfValuesComponent)
	.name;
